"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReducedInequalities = void 0;
var React = __importStar(require("react"));
var ReducedInequalities = function (_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "48",
    height: "48",
    viewBox: "0 0 520.9 604"
  }, React.createElement("g", null, React.createElement("g", {
    transform: "translate(0.000000, -1.000000)"
  }, React.createElement("g", {
    transform: "translate(0.000000, 0.022030)"
  }, React.createElement("path", {
    fill: "#DC0A79",
    d: "M385.4,421.8c0.9,0,1.6,0.7,1.6,1.6v32.9c0,0.9-0.7,1.6-1.6,1.6h-145c-0.9,0-1.6-0.7-1.6-1.6\n        v-32.9c0-0.9,0.7-1.6,1.6-1.6L385.4,421.8L385.4,421.8z"
  }), React.createElement("path", {
    fill: "#DC0A79",
    d: "M470.9,374.4c-5.9-23.9-16.8-45.3-31.1-63.5l-0.3,0.2c4.7,6.9,8.8,14.3,12.4,22\n        c18.8,34.5,24.6,76.2,12.7,117c-23.8,81.8-109.3,128.7-191,104.9c-34.3-10-62.5-31-81.9-58c-12.1-15.6-21.3-33.9-26.3-54.2\n        c-19.4-78,28.1-157,106-176.5c48.2-12,96.7,1.7,131.3,32.3c0.3,0.3,0.6,0.6,0.9,0.8c0.9,0.7,2,1.2,3.3,1.2c1.4,0,2.6-0.6,3.6-1.4\n        l0.6-0.6l18.5-18.3l1.2-1.2c0.7-0.9,1.2-2,1.2-3.3c0-1.5-0.6-2.7-1.5-3.7c-0.2-0.2-0.4-0.4-0.6-0.5\n        c-42.6-38.1-102.6-55.2-162.2-40.4C172,255.1,113.7,352.1,137.5,448c10,40.2,32.8,73.7,63,97.4c30.1,24.7,68.4,38.7,108.5,38.3\n        c12.9-0.1,26-1.7,39.1-5C438.4,556.4,493.4,464.8,470.9,374.4"
  }), React.createElement("path", {
    fill: "#DC0A79",
    d: "M387,361.6c0-0.9-0.7-1.6-1.6-1.6H265.2h-24.8c-0.9,0-1.6,0.7-1.6,1.6v13v20\n        c0,0.9,0.7,1.6,1.6,1.6h145c0.9,0,1.6-0.7,1.6-1.6L387,361.6L387,361.6z"
  }), React.createElement("polygon", {
    fill: "#DC0A79",
    points: "17.8,37.1 17.8,149.4 42.4,149.4 42.4,2.8 22.7,2.8 0,29.4 0,55.1 0.3,55.1 \n        17.5,37.1"
  }), React.createElement("path", {
    fill: "#DC0A79",
    d: "M84.1,115.4V36.7c0-8.9,3.2-15.1,11.7-15.1c8.6,0,11.9,6.3,11.9,15.1v78.7\n        c0,8.9-3.2,15.1-11.9,15.1C87.3,130.6,84.1,124.3,84.1,115.4 M132.2,111.5V40.6C132.2,17.7,120.8,1,95.7,1\n        C70.9,1,59.4,17.6,59.4,40.6v70.9c0,22.7,11.5,39.6,36.3,39.6C120.8,151.1,132.2,134.2,132.2,111.5"
  }), React.createElement("path", {
    fill: "#DC0A79",
    d: "M192.3,11.4v19.1h3.4c3.5,0,5.1-1.8,5.1-5.1v-9c0-3.3-1.5-5-5.1-5H192.3z M192.3,36.1v28.1\n        H182V3h15c10.4,0,14.2,5.1,14.2,13.7v7.9c0,6.6-2.3,10.5-8.2,11.8l9.8,27.8H202L192.3,36.1z"
  }), React.createElement("polygon", {
    fill: "#DC0A79",
    points: "216.7,3 241.3,3 241.3,11.4 227,11.4 227,28.9 237.2,28.9 237.2,37.2 227,37.2 \n        227,55.8 241.3,55.8 241.3,64.2 216.7,64.2"
  }), React.createElement("path", {
    fill: "#DC0A79",
    d: "M261.4,55.8c4.2,0,5.9-2.5,5.9-6.2V17.5c0-3.6-1.6-6.1-5.9-6.1h-4.3v44.4\n        C257.1,55.8,261.4,55.8,261.4,55.8z M277.5,19.4v28.4c0,9.4-3.9,16.4-14.9,16.4h-15.9V3h15.9C273.6,3,277.5,9.9,277.5,19.4z"
  }), React.createElement("path", {
    fill: "#DC0A79",
    d: "M313.2,3v46.3c0,9.5-4.1,15.6-14.5,15.6c-10.8,0-15.3-6.1-15.3-15.6V3h10.3v47.3\n        c0,3.6,1.4,6,5.1,6c3.6,0,5.1-2.4,5.1-6V3H313.2z"
  }), React.createElement("path", {
    fill: "#DC0A79",
    d: "M319.1,48.4V18.8c0-9.6,4.5-16.5,15.3-16.5c11.4,0,14.5,6.3,14.5,15.4v7.2h-9.4v-8\n        c0-3.8-1.3-6-5-6s-5.2,2.6-5.2,6.3v32.9c0,3.7,1.5,6.3,5.2,6.3s5-2.3,5-6V39.1h9.4v10.6c0,8.8-3.6,15.3-14.5,15.3\n        C323.6,64.9,319.1,57.9,319.1,48.4"
  }), React.createElement("polygon", {
    fill: "#DC0A79",
    points: "354.5,3 379,3 379,11.4 364.8,11.4 364.8,28.9 375,28.9 375,37.2 364.8,37.2 \n        364.8,55.8 379,55.8 379,64.2 354.5,64.2"
  }), React.createElement("path", {
    fill: "#DC0A79",
    d: "M399.1,55.8c4.2,0,5.9-2.5,5.9-6.2V17.5c0-3.6-1.6-6.1-5.9-6.1h-4.3v44.4\n        C394.8,55.8,399.1,55.8,399.1,55.8z M415.3,19.4v28.4c0,9.4-3.9,16.4-14.9,16.4h-15.9V3h15.9C411.4,3,415.3,9.9,415.3,19.4z"
  }), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#DC0A79",
    points: "182,150 192.3,150 192.3,88.7 182,88.7"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#DC0A79",
    points: "206.9,111.5 206.9,150 198.2,150 198.2,88.7 208.3,88.7 219.4,123.9 219.4,88.7 \n          228,88.7 228,150 219,150"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#DC0A79",
    points: "233.9,88.7 258.4,88.7 258.4,97.1 244.1,97.1 244.1,114.7 254.3,114.7 254.3,123 \n          244.1,123 244.1,141.6 258.4,141.6 258.4,150 233.9,150"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("path", {
    fill: "#DC0A79",
    d: "M283.8,136.3v-33.4c0-3.7-1.6-6.3-5.3-6.3c-3.6,0-5.2,2.6-5.2,6.3v33.4\n          c0,3.6,1.6,6.3,5.2,6.3C282.2,142.7,283.8,139.9,283.8,136.3z M274.7,154.1v-4.2c-8.2-1.4-11.7-7.5-11.7-15.8v-29.6\n          c0-9.6,4.7-16.5,15.5-16.5c10.9,0,15.6,7,15.6,16.5v29.6c0,6.7-2.3,11.9-7.6,14.5l7.6,1.4v7.7L274.7,154.1z"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("path", {
    fill: "#DC0A79",
    d: "M329.8,88.7V135c0,9.5-4.1,15.6-14.5,15.6c-10.8,0-15.3-6.1-15.3-15.6V88.7h10.3V136\n          c0,3.6,1.4,6,5.1,6c3.6,0,5-2.4,5-6V88.7H329.8z"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("path", {
    fill: "#DC0A79",
    d: "M345.6,130.6h8.2l-4.1-24.6h-0.1L345.6,130.6z M332.7,150l11.5-61.2h11.7l11.6,61.2H357\n          l-1.9-11.2h-10.9l-1.8,11.2H332.7z"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#DC0A79",
    points: "371.8,88.7 382.1,88.7 382.1,141.6 394.4,141.6 394.4,150 371.8,150"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#DC0A79",
    points: "399,150 409.3,150 409.3,88.7 399,88.7"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#DC0A79",
    points: "414.1,88.7 441.4,88.7 441.4,97.1 433,97.1 433,150 422.6,150 422.6,97.1 \n          414.1,97.1"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#DC0A79",
    points: "446.2,150 456.5,150 456.5,88.7 446.2,88.7"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#DC0A79",
    points: "462.4,88.7 487,88.7 487,97.1 472.7,97.1 472.7,114.7 482.9,114.7 482.9,123 \n          472.7,123 472.7,141.6 487,141.6 487,150 462.4,150"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("path", {
    fill: "#DC0A79",
    d: "M491.5,136.8v-8.2h9.6v8.4c0,3.4,1.5,5.4,5,5.4c3.2,0,4.7-2.2,4.7-5.4v-2.3\n          c0-3.5-1.4-5.7-4.6-8.7l-6-6c-5.9-5.8-8.6-9.3-8.6-16.3v-2.1c0-7.6,4.4-13.5,14.4-13.5c10.3,0,14.3,5.1,14.3,13.9v5h-9.4v-5.3\n          c0-3.5-1.6-5.2-4.9-5.2c-2.9,0-4.9,1.6-4.9,5.1v1.3c0,3.4,1.9,5.4,4.9,8.3l6.6,6.5c5.6,5.7,8.3,9.1,8.3,15.9v3\n          c0,8.4-4.5,14.4-15,14.4C495.5,150.7,491.5,144.8,491.5,136.8"
  }))))));
};
exports.ReducedInequalities = ReducedInequalities;